import Vue from "vue";

const CONFIG_API = {
    filter: "/pc/product/route-cruises-filter",
    destList:"/pc/product/route-cruises",//邮轮目的地产品列表
    allDest:'/pc/product/route-cruises-home',
    routeList:'/pc/route/list',
}

export function getDestFilter(data) {
    return Vue.$axios.$post(CONFIG_API.filter, { data });
}

export function getDestList(data){
    return Vue.$axios.$post(CONFIG_API.destList, { data })
}

export function getAllDests(){
    return Vue.$axios.$get(CONFIG_API.allDest)
}

export function getAllRouteList(){
    return Vue.$axios.$post(CONFIG_API.routeList)
}